import { getAnimatedLink } from '@brickken/dapp-theme';
import { Theme } from '@mui/material/styles';

export const onRamperStyles = (theme: Theme, isCard: boolean) => ({
  link: {
    fontVariationSettings: "'wght' 600",
    pl: 1,
    textDecoration: 'none',
    ...getAnimatedLink(theme),
    background: `linear-gradient(89.66deg,${theme.palette.primary.main} 15%,#D4F54C 40%,${theme.palette.primary.main} 60%)`
  },
  container: { pt: isCard ? 0.75 : 0, pl: isCard ? 0.75 : 0 },
  text: {
    pl: isCard ? 0 : 1.5,
    fontVariationSettings: "'wght' 400",
    fontSize: isCard ? '11px' : '13px',
    [theme.breakpoints.down('md')]: {
      color: theme.palette.primary.main,
      pl: 0
    }
  }
});
